<template>
  <div id="sidebar" class="sidebar">
    <!-- begin sidebar scrollbar -->
    <div data-scrollbar="true" data-height="100%">
      <!-- begin sidebar nav -->
      <ul class="nav">
        <li class="nav-header">Navigation</li>
        <router-link to="/" tag="li"
          ><a><i class="fa fa-tachometer"></i><span>Dashboard</span></a></router-link
        >
        <usman-nav v-if="$store.state.auth.scopes.includes('admin_userman')"></usman-nav>
        <sbmptn-nav
          v-if="$store.state.auth.scopes.includes('admin_itembank')"
        ></sbmptn-nav>
        <tryoutgroup-nav
          v-if="$store.state.auth.scopes.includes('admin_itembank')"
        ></tryoutgroup-nav>
        <!-- <tryout-nav
          v-if="$store.state.auth.scopes.includes('admin_itembank')"
        ></tryout-nav>
        <serial-nav
          v-if="$store.state.auth.scopes.includes('admin_itembank')"
        ></serial-nav> -->
        <organizations-nav
          v-if="$store.state.auth.scopes.includes('admin_userman')"
        ></organizations-nav>
        <affiliate-nav v-if="$store.state.auth.scopes.includes('admin_sales')"></affiliate-nav>

        <itembank-nav
          v-if="$store.state.auth.scopes.includes('admin_itembank')"
        ></itembank-nav>
        <kodifikasi-nav
          v-if="$store.state.auth.scopes.includes('admin_itembank')"
        ></kodifikasi-nav>
        <modulbelajar-nav
          v-if="$store.state.auth.scopes.includes('admin_modul_belajar')"
        ></modulbelajar-nav>

        <teacher-nav
          v-if="$store.state.auth.scopes.includes('admin_userman')"
        ></teacher-nav>


        <duel-nav v-if="$store.state.auth.scopes.includes('admin_itembank')"></duel-nav>
        <pembayaran-nav
          v-if="$store.state.auth.scopes.includes('admin_sales')"
        ></pembayaran-nav>
        <voucher-nav
          v-if="$store.state.auth.scopes.includes('admin_sales')"
        ></voucher-nav>
        <video-nav v-if="$store.state.auth.scopes.includes('admin_itembank')"></video-nav>

        <pushnotif-nav></pushnotif-nav>
        
        <bimbel-nav
          v-if="$store.state.auth.scopes.includes('admin_itembank')"
        ></bimbel-nav>
        <content-nav></content-nav>
        <!-- <config-management-nav></config-management-nav> -->
        <!-- <iklan-nav v-if="$store.state.auth.scopes.includes('admin_sales')"></iklan-nav> -->
        <!-- begin sidebar minify button -->
        <li>
          <a href="javascript:;" class="sidebar-minify-btn" data-click="sidebar-minify"
            ><i class="fa fa-angle-double-left"></i
          ></a>
        </li>
        <!-- end sidebar minify button -->
      </ul>
      <!-- end sidebar nav -->
    </div>
    <!-- end sidebar scrollbar -->
  </div>
</template>

<script>
import ItembankNav from "@/components/itembank/Navigation";
import TryoutNav from "@/components/tryout/Navigation";
import TryoutGroupNav from "@/components/tryout_group/Navigation";
import UserManagementNav from "@/components/usman/Navigation";
import KodifikasiNav from "@/components/kodifikasi/Navigation";
import SerialNav from "@/components/serial/Navigation";
import VideoNav from "@/components/vd_pembelajaran/Navigation";
import ModulBelajarNav from "@/components/modul_pembelajaran/Navigation";
import PembayaranNav from "@/components/pembayaran/Navigation";
import DuelNav from "@/components/duel/Navigation";
import BimbelNav from "@/components/bimbel_online/Navigation";
import ContentNav from "@/components/home_setting/Navigation";
import OrganizationsNav from "@/components/organizations/Navigation";
import ConfigurationManagementNav from "@/components/config_management/Navigation";
import SbmptnNav from "@/components/sbmptn/Navigation";
import VoucherNav from "@/components/voucher/Navigation";
import IklanNav from "@/components/iklan/Navigation";
import AffiliateNav from "@/components/affiliate/Navigation";
import PushNotifNav from "@/components/push_notif/Navigation";
import TeacherNav from "@/components/teacher/Navigation";

export default {
  name: "sidebar",
  components: {
    "itembank-nav": ItembankNav,
    "tryout-nav": TryoutNav,
    "tryoutgroup-nav": TryoutGroupNav,
    "usman-nav": UserManagementNav,
    "kodifikasi-nav": KodifikasiNav,
    "serial-nav": SerialNav,
    "video-nav": VideoNav,
    "modulbelajar-nav": ModulBelajarNav,
    "pembayaran-nav": PembayaranNav,
    "duel-nav": DuelNav,
    "bimbel-nav": BimbelNav,
    "content-nav": ContentNav,
    "organizations-nav": OrganizationsNav,
    "config-management-nav": ConfigurationManagementNav,
    "sbmptn-nav": SbmptnNav,
    "voucher-nav": VoucherNav,
    "iklan-nav": IklanNav,
    "affiliate-nav": AffiliateNav,
    "pushnotif-nav": PushNotifNav,
    "teacher-nav": TeacherNav
  },

  data: function () {
    return {
      scopes: [],
    };
  },
  mounted: function () {
    App.init();
  },
};
</script>



// WEBPACK FOOTER //
// Sidebar.vue?c65335e8